"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Fieldset = exports.SortOrder = exports.Type = void 0;
var Type;
(function (Type) {
    Type["AREA"] = "AREA";
    Type["ROW"] = "ROW";
    Type["MULTI_ROW"] = "MULTI_ROW";
    Type["TABLE"] = "TABLE";
    Type["ROUND_TABLE"] = "ROUND_TABLE";
    Type["SHAPE"] = "SHAPE";
})(Type = exports.Type || (exports.Type = {}));
var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder = exports.SortOrder || (exports.SortOrder = {}));
var Fieldset;
(function (Fieldset) {
    Fieldset["ELEMENTS"] = "ELEMENTS";
    Fieldset["CATEGORIES"] = "CATEGORIES";
    Fieldset["PLACES"] = "PLACES";
    Fieldset["CONFIG"] = "CONFIG";
})(Fieldset = exports.Fieldset || (exports.Fieldset = {}));
//# sourceMappingURL=types.js.map